export default class FilterEncoder {
    static formatTwoDecimalNumber(num) {
        if (!num) {
            return '00';
        }

        return num < 10 ? `0${num}` : num;
    }

    static encode(searchParams, filters) {
        let url = `${searchParams.currency ? searchParams.currency : ''}|${searchParams.language ? searchParams.language : ''}|${searchParams.departureCity}|${searchParams.arrivalCity}|${searchParams.departureDate}|${searchParams.returnDate ? searchParams.returnDate : ''}`;
        url += `|${this.formatTwoDecimalNumber(searchParams.adults ? searchParams.adults : 1)}${this.formatTwoDecimalNumber(searchParams.children)}${this.formatTwoDecimalNumber(searchParams.infants)}`

        url += `|${filters.sort}`;
        url += `|${filters.page}`;
        url += `|${JSON.stringify(filters.carriers)}`;
        url += `|${filters.transfer}`;
        url += filters.duration ? `|${filters.duration.start};${filters.duration.end}` : '|';
        url += `|${filters.forwardTime.type};${filters.forwardTime.start};${filters.forwardTime.end}`;
        url += `|${filters.returnTime.type};${filters.returnTime.start};${filters.returnTime.end}`;
        url += `|${filters.stops}`;
        url += `|${+filters.noNightTransfer}`;
        url += `|${JSON.stringify(filters.arrivalAirports)}`;
        url += `|${JSON.stringify(filters.returnAirports)}`;
        url += `|${JSON.stringify(filters.stopAirports)}`;
        url += `|${filters.baggage.included ? 'i' : ''}${filters.baggage.excluded ? 'e' : ''}`;

        return url
    }

    static decode(filters) {
        const parts = filters.split('|');

        return {
            search: {
                currency: parts[0],
                language: parts[1],
                departureCity: parts[2],
                arrivalCity: parts[3],
                departureDate: parts[4],
                returnDate: parts[5],
                adults: parseInt(parts[6].substring(0, 2), 10),
                children: parseInt(parts[6].substring(2, 4), 10),
                infants: parseInt(parts[6].substring(4, 6), 10)
            },
            filters: {
                sort: parts[7],
                page: parts[8],
                carriers: JSON.parse(parts[9]),
                transfer: parts[10],
                duration: {
                    start: parts[11].split(';')[0],
                    end: parts[11].split(';')[1]
                },
                forwardTime: {
                    type: parts[12].split(';')[0],
                    start: parts[12].split(';')[1],
                    end: parts[12].split(';')[2]
                },
                returnTime: {
                    type: parts[13].split(';')[0],
                    start: parts[13].split(';')[1],
                    end: parts[13].split(';')[2]
                },
                stops: parts[14],
                noNightTransfer: !!parseInt(parts[15], 10),
                arrivalAirports: JSON.parse(parts[16]),
                returnAirports: JSON.parse(parts[17]),
                stopAirports: JSON.parse(parts[18]),
                baggage: {
                    selected: {
                        included: parts[19] === '' ? true : (parts[19][0] === 'i' || parts[19][1] === 'i'),
                        excluded: parts[19] === '' ? true : (parts[19][0] === 'e' || parts[19][1] === 'e')
                    }
                },
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/helpers/FilterEncoder.js